const VALID_TIMEZONES = ["PKT", "GMT", "UTC", "EST", "CST", "MST", "PST"];

export const TIMEZONE_OPTIONS = ["UTC", "GMT", "EST", "CST", "MST", "PST", "PKT"];

export const getSafeTimezone = (timezone) =>
  VALID_TIMEZONES.includes(timezone) ? timezone : "UTC";

const ROLE_DISPLAY_LABELS = {
  admin: "Admin",
  owner: "Owner",
  manager: "Manager",
  viewer: "Viewer",
  superadmin: "Superadmin",
  developer: "Developer",
  support: "Support",
};

export const ADMIN_ROLE_VALUES = Object.keys(ROLE_DISPLAY_LABELS);

export const getDisplayRole = (user) => {
  const backendRole = (user.user_role || "").toString().trim().toLowerCase();
  return ROLE_DISPLAY_LABELS[backendRole] || "Viewer";
};

export const normalizeRoleForApi = (role) => {
  const selectedRole = (role || "").toString().trim().toLowerCase();
  if (selectedRole === "owner") return "owner";
  if (selectedRole === "manager") return "manager";
  if (selectedRole === "admin") return "admin";
  return "viewer";
};

export const toAdminUser = (user) => ({
  id: user.id,
  name: [user.firstname, user.lastname].filter(Boolean).join(" ") || user.email,
  email: user.email || "",
  role: getDisplayRole(user),
  backendRole: user.user_role || "",
  mfaEnabled: Boolean(user.two_fa_enabled),
  avatar: null,
});

export const getUsersList = (response) => {
  if (Array.isArray(response?.users)) return response.users;
  if (Array.isArray(response)) return response;
  return [];
};

// A role change should only send the role
export const buildUserPayload = (user, role) => ({
  user_role: normalizeRoleForApi(role),
});

export const buildAccountPayload = (user, { timezone, twoFaEnabled }) => {
  const payload = {
    firstname: user.firstname || "",
    lastname: user.lastname || "",
    phone: user.phone || undefined,
    sms_notification: Boolean(user.sms_notification),
    timezone: getSafeTimezone(timezone || user.timezone),
    user_status: user.user_status || "enabled",
    two_fa_enabled: Boolean(twoFaEnabled),
  };

  if (!user.user_type || user.user_type === "console") {
    payload.user_role = normalizeRoleForApi(user.user_role || "viewer");
  }

  return payload;
};
